import React, { useContext } from 'react'
import { getImages } from '../Components/const'
import { Field, Form, Formik, ErrorMessage } from 'formik';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import ReCAPTCHA from 'react-google-recaptcha';
import { VehicleContext } from '../Components/Context/VehicleContext';
import SeoMeta from '../Components/Common/SeoMeta';
import { useNavigate } from 'react-router-dom';

const Blog = () => {
    const {submitContactForm} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();
    const navigate = useNavigate();

    UseScrollReveal();
    return (
        <>
            <SeoMeta
                title="Blog | Official McLaren Dealership in Orlando, FL | McLaren Orlando"
                description="McLaren Orlando's blog connects you to the latest news, events, racing, and special releases! Visit McLaren Orlando and discover your future McLaren today!"
                keywords=""
                ogTitle="Blog | Official McLaren Dealership in Orlando, FL | McLaren Orlando"
                ogDescription="McLaren Orlando's blog connects you to the latest news, events, racing, and special releases! Visit McLaren Orlando and discover your future McLaren today!"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('blog-hero-bg.webp')} alt='Blog' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h3 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando Blog</h3>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Latest News</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <a href='tel:4079880111' className='theme-btn text-uppercase d-inline-block'>407-988-0111</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='blog-wrap'>
                <div className='container'>
                    <div className='blog-flex d-lg-flex'>
                        <div className='blog-left'>
                            <div className='blog-box wow reveal fadeInUp'>
                                <h2 className='md-title font-1-5em text-uppercase fw-400 mb-md-4 mb-3'>McLaren Daniel Ricciardo Edition 720S from MSO takes to the streets of Melbourne</h2>
                                <div className='d-flex'>
                                    <div className='blog-thumb'>
                                        <img src={getImages('blog-thumb.webp')} />
                                    </div>
                                    <div className='ps-md-4 ps-3'>
                                        <div className='xs-title text-orange fw-700 mb-2 text-uppercase'>June 13, 2024</div>
                                        <p>The new Daniel Ricciardo Edition 720S from McLaren Special Operations (MSO), McLaren’s in-house bespoke division, has broken cover, arriving in Australia. Taking in Albert Park, the home of the Australian Grand Prix, as well as the St Kilda foreshore, the special commission 720S is just one of a limited series ...</p>
                                        <div className='text-end mt-3'>
                                            <a href='#' className='learn-more-btn d-inline-block'>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='blog-box wow reveal fadeInUp'>
                                <h2 className='md-title font-1-5em text-uppercase fw-400 mb-md-4 mb-3'>This Season's Ultimate McLaren Gift Guide</h2>
                                <div className='d-flex'>
                                    <div className='blog-thumb'>
                                        <img src={getImages('blog-thumb.webp')} />
                                    </div>
                                    <div className='ps-md-4 ps-3'>
                                        <div className='xs-title text-orange fw-700 mb-2 text-uppercase'>June 13, 2024</div>
                                        <p>Just in time for the gift-giving season, luxury supercar maker McLaren Automotive has curated the ultimate holiday wish-list for both owners and fans of the brand. For the traveler in your life, TUMI and McLaren have developed a capsule collection of luggage and travel accessories focusing on unparalleled quality, technical ...</p>
                                        <div className='text-end mt-3'>
                                            <a href='#' className='learn-more-btn d-inline-block'>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='blog-box wow reveal fadeInUp'>
                                <h2 className='md-title font-1-5em text-uppercase fw-400 mb-md-4 mb-3'>Castore Unveil Summer Sportswear Collection</h2>
                                <div className='d-flex'>
                                    <div className='blog-thumb'>
                                        <img src={getImages('blog-thumb.webp')} />
                                    </div>
                                    <div className='ps-md-4 ps-3'>
                                        <div className='xs-title text-orange fw-700 mb-2 text-uppercase'>June 13, 2024</div>
                                        <p>Pioneering luxury supercar company McLaren Automotive today unveils its summer capsule collection with British premium sportswear brand Castore. Following a successful autumn/winter collection in 2020, the collaboration between the two performance brands introduces a new line of technical clothing suited to performance amid the rigors of everyday life. Inspired by ...</p>
                                        <div className='text-end mt-3'>
                                            <a href='#' className='learn-more-btn d-inline-block'>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='blog-box wow reveal fadeInUp'>
                                <h2 className='md-title font-1-5em text-uppercase fw-400 mb-md-4 mb-3'>McLaren Elva X Pato O'Ward - 'Challenge the wind' Film</h2>
                                <div className='d-flex'>
                                    <div className='blog-thumb'>
                                        <img src={getImages('blog-thumb.webp')} />
                                    </div>
                                    <div className='ps-md-4 ps-3'>
                                        <div className='xs-title text-orange fw-700 mb-2 text-uppercase'>June 13, 2024</div>
                                        <p>Fresh from claiming a third-place finish in only his second full year in the NTT INDYCAR SERIES, Arrow McLaren SP race car driver Pato O’Ward has now experienced pure driving exhilaration from behind the wheel of the McLaren Elva – a hypercar that blurs the boundaries between the car and ...</p>
                                        <div className='text-end mt-3'>
                                            <a href='#' className='learn-more-btn d-inline-block'>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='blog-right'>
                            <div className='blog-box wow reveal fadeInUp'>
                                <h2 className='md-title font-1-9em text-uppercase fw-400 mb-3'>Join the club</h2>
                                <div className='xs-title mb-4'>Stay updated with our latest tips and other news by joining our newsletter.</div>
                                <Formik
                                    initialValues={{
                                        email: ''
                                    }}
                                    onSubmit={async (values, { resetForm }) => {
                                        const token = await recaptchaRef.current.executeAsync();
                                        recaptchaRef.current.reset(); // Reset after use

                                        values.token = token;

                                        console.log(values);
                                        const data = await submitContactForm(values);

                                        if (data.success) {
                                            resetForm();
                                            navigate("/thank-you");
                                            // alert("Thank you for your submission. We'll be in touch soon!");
                                        } else
                                            alert("There was a problem with your submission");
                                    }}
                                >
                                    {({ values, setFieldValue, field, form }) => (
                                        <Form className="custom-form vdp-contact-form" autoComplete="off" name="contact-form">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                                size="invisible"
                                            />
                                            <div className='form-group mb-4'>
                                                <Field
                                                    type="text"
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter Email"
                                                    required 
                                                />
                                                <ErrorMessage name="email" component="div" className="text-danger" />
                                            </div>
                                            <button className='theme-btn text-uppercase w-100'>Sign Up</button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                            <div className='mt-4 blog-lease-box  wow reveal fadeInUp'>
                                <div className='blb-image'>
                                    <img src={getImages('blog-r-img.webp')} />
                                </div>
                                <div className='blb-content'>
                                    <div className='d-flex'>
                                        <div className='xs-title text-orange font-1-1em fw-700 mb-2 text-uppercase'>Lease Special</div>
                                        <div>
                                            <button className='info-icon'>
                                                <img src={getImages('info-icon.svg')} alt='icon' />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='xs-title fw-400'>2023 McLaren Artura Performance</div>
                                    <div className='d-flex align-items-center mt-1'>
                                        <div className='xs-title font-1-9em fw-700'>$2,399</div>
                                        <div className='per-month-text ps-3'>Per Month</div>
                                    </div>
                                    <p>Lease offer valid thru Nov 30, 2025. As advertised lorem ipsum semper duet with har daus kradem… <a href='#'>More details</a></p>
                                    <div className='mt-4 text-center'>
                                        <a href='#' className='theme-btn text-uppercase w-100'>View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog